// core/lib/deviceLabel.ts — "Chrome on Windows" for the Account Settings "This device" row.
// Read from this browser's own user agent: it describes the session you are looking
// from, and nothing is sent anywhere. Order matters: Edge and Opera also say "Chrome",
// and every iOS browser says "Safari".

export interface DeviceLabel {
  browser: string;
  os: string;
  mobile: boolean;
}

export function deviceLabel(userAgent: string): DeviceLabel {
  const ua = userAgent || '';
  const os = /iPhone|iPad|iPod/.test(ua)
    ? 'iOS'
    : /Android/.test(ua)
      ? 'Android'
      : /CrOS/.test(ua)
        ? 'ChromeOS'
        : /Windows/.test(ua)
          ? 'Windows'
          : /Mac OS X|Macintosh/.test(ua)
            ? 'macOS'
            : /Linux/.test(ua)
              ? 'Linux'
              : 'an unknown system';
  const browser = /Edg(e|A|iOS)?\//.test(ua)
    ? 'Edge'
    : /OPR\/|Opera/.test(ua)
      ? 'Opera'
      : /SamsungBrowser/.test(ua)
        ? 'Samsung Internet'
        : /Firefox|FxiOS/.test(ua)
          ? 'Firefox'
          : /Chrome|CriOS/.test(ua)
            ? 'Chrome'
            : /Safari/.test(ua)
              ? 'Safari'
              : 'A browser';
  return { browser, os, mobile: /Mobi|iPhone|Android/.test(ua) };
}
